module.exports = __webpack_public_path__ + "static/daya_nail_story-35ea5bb6e080bb6b4156f0b70f424c21.png";